import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './_card.css'
import StatRollup from './StatRollup'
import Waypoint from 'react-waypoint'
import messages from './messages'

function Stat (props) {
  const {
    activateStatCard,
    activeCards,
    id,
    stat,
  } = props

  const isActive = activeCards.includes(id)
  const captionValue = stat.captionValue.toLocaleString(undefined, { maximumFractionDigits: 0 })
  const { headline, caption } = messages[id]

  return (
    <div className={styles.cardStat}>
      <h2 className={styles.cardTitle}>
        <StatRollup
          isActive={isActive}
          stat={stat.number}
          format={ stat.formatOptions || { maximumFractionDigits: 0 } }
        /><br />
        { headline ? <FormattedMessage {...headline} /> : null }
      </h2>
      <p className={styles.cardCaption}>
        { caption ? <FormattedMessage {...caption} values={ { captionValue } } /> : null }
        <div className={styles.waypoint}>
          <Waypoint onEnter={ () => { if (!isActive) { activateStatCard(id) } } } bottomOffset="-70px" />
        </div>
      </p>
    </div>
  )
}

Stat.propTypes = {
  activateStatCard: PropTypes.func,
  activeCards: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  stat: PropTypes.object,
}

export default Stat



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Card/Stat.jsx